import { render, staticRenderFns } from "./ConfigInputNumber.vue?vue&type=template&id=6b805cc7&"
import script from "./ConfigInputNumber.vue?vue&type=script&lang=js&"
export * from "./ConfigInputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b805cc7')) {
      api.createRecord('6b805cc7', component.options)
    } else {
      api.reload('6b805cc7', component.options)
    }
    module.hot.accept("./ConfigInputNumber.vue?vue&type=template&id=6b805cc7&", function () {
      api.rerender('6b805cc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputNumber.vue"
export default component.exports